let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2kf00")).then(() => parcelRequire('3QaCW'));